import { borderedStyles as borderedStyles$1 } from "./styles/external/bordered.styles.js";
import { filledStyles as filledStyles$1 } from "./styles/external/filled.styles.js";
import { borderedStyles } from "./styles/internal/bordered.styles.js";
import { borderlessStyles } from "./styles/internal/borderless.styles.js";
import { filledStyles } from "./styles/internal/filled.styles.js";
import { shadowedStyles } from "./styles/internal/shadowed.styles.js";
import "color-alpha";
const MuiButton = {
  defaultProps: {
    variant: "filled",
    color: "aqua",
    size: "md"
  },
  styleOverrides: {
    root: ({ ownerState, theme }) => ({
      textTransform: "initial",
      borderRadius: "999px",
      width: "fit-content",
      ...ownerState.fullWidth && {
        width: "100%"
      },
      ...ownerState.size === "xl" && {
        ...theme.typography["Lato Emphasized 1"],
        height: "56px",
        padding: "6px 32px",
        ".MuiSvgIcon-root": {
          width: "24px",
          height: "24px"
        },
        ".MuiButton-startIcon": {
          margin: "0 12px 0 0"
        },
        ".MuiButton-endIcon": {
          margin: "0 0 0 12px"
        }
      },
      ...ownerState.size === "lg" && {
        ...theme.typography["Lato Emphasized 2"],
        height: "48px",
        padding: "6px 32px",
        ".MuiSvgIcon-root": {
          width: "20px",
          height: "20px"
        },
        ".MuiButton-startIcon": {
          margin: "0 8px 0 0"
        },
        ".MuiButton-endIcon": {
          margin: "0 0 0 8px"
        }
      },
      ...ownerState.size === "md" && {
        ...theme.typography["Lato Emphasized 2"],
        height: "40px",
        padding: "6px 24px",
        ...theme.variant === "external" && {
          padding: "10px 24px"
        },
        ".MuiSvgIcon-root": {
          width: "16px",
          height: "16px"
        },
        ".MuiButton-startIcon": {
          margin: "0 8px 0 0"
        },
        ".MuiButton-endIcon": {
          margin: "0 0 0 8px"
        }
      },
      ...ownerState.size === "sm" && {
        ...theme.typography["Lato Button"],
        height: "32px",
        padding: "8px 16px",
        textTransform: "uppercase",
        ".MuiSvgIcon-root": {
          width: "16px",
          height: "16px"
        },
        ".MuiButton-startIcon": {
          margin: "0 8px 0 0"
        },
        ".MuiButton-endIcon": {
          margin: "0 0 0 8px"
        }
      },
      ...ownerState.size === "xs" && {
        ...theme.typography["Lato Overline Bold"],
        height: "24px",
        padding: "6px 12px",
        textTransform: "uppercase",
        ".MuiSvgIcon-root": {
          width: "14px",
          height: "14px"
        },
        ".MuiButton-startIcon": {
          margin: "0 4px 0 0"
        },
        ".MuiButton-endIcon": {
          margin: "0 0 0 4px"
        }
      },
      ...ownerState.size === "xxs" && {
        ...theme.typography["Lato Overline Bold"],
        height: "20px",
        padding: "4px 8px",
        textTransform: "uppercase",
        ".MuiSvgIcon-root": {
          width: "10px",
          height: "10px"
        },
        ".MuiButton-startIcon": {
          margin: "0 4px 0 0"
        },
        ".MuiButton-endIcon": {
          margin: "0 0 0 4px"
        }
      },
      ...theme.variant === "internal" && {
        ...filledStyles({ theme, ownerState }),
        ...borderedStyles({ theme, ownerState }),
        ...shadowedStyles({ theme, ownerState }),
        ...borderlessStyles({ theme, ownerState })
      },
      ...theme.variant === "external" && {
        ...borderedStyles$1({ theme, ownerState }),
        ...filledStyles$1({ theme, ownerState })
      }
    })
  }
};
export {
  MuiButton
};
